// @core/api/endpoints/billing/get_trial_balance.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTrialBalanceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get trial balance report
 * Generates a trial balance report showing all account balances as of the specified date. Debits and credits should equal to verify ledger integrity.
 */
export async function GetTrialBalance(
  params?: {
    as_of?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<GetTrialBalanceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/reports/trial-balance`;
  const requestOptions = options;
  return client.get<GetTrialBalanceResponse>(requestPath, { ...requestOptions, params });
}
